import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/Client.api';

export const uploadClientMasterRequest = (fileData) => ({
  type: actionTypes.UPLOAD_CLIENT_MASTER_REQUEST,
  payload: fileData,
});

export const uploadClientMasterSuccess = (message) => ({
  type: actionTypes.UPLOAD_CLIENT_MASTER_SUCCESS,
  payload: message,
});

export const uploadClientMasterFailure = (error) => ({
  type: actionTypes.UPLOAD_CLIENT_MASTER_FAILURE,
  payload: error,
});

export const uploadClientMasterFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadClientMasterRequest(fileData));
    try {
      const response = await api.uploadClientMaster(fileData);
      // showSnackbar(response, 'success');
      dispatch(uploadClientMasterSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(uploadClientMasterFailure(error));
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };
    }
  };
};

export const multiDaleteClientMasterRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_UNIT_REQUEST,
  payload: ids,
});

export const multiDaleteClientMasterSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_UNIT_SUCCESS,
  payload: message,
});

export const multiDaleteClientMasterFailure = (error) => ({
  type: actionTypes.MULTIDELETE_UNIT_FAILURE,
  payload: error,
});

export const multiDeleteClientMasterFile = (ids) => {
  console.log(ids);
  return async (dispatch) => {
    dispatch(multiDaleteClientMasterRequest(ids));
    try {
      const response = await api.multiDeleteClientMaster(ids);
      // showSnackbar(response, 'success');
      dispatch(multiDaleteClientMasterSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteClientMasterFailure(error));
      return { success: false, message: error };
    }
  };
};



export const getClientsRequest = () => ({
  type: actionTypes.GET_CLIENTS_REQUEST,
});

export const getClientsSuccess = (clients) => ({
  type: actionTypes.GET_CLIENTS_SUCCESS,
  payload: clients,
});

export const getClientsFailure = (error) => ({
  type: actionTypes.GET_CLIENTS_FAILURE,
  payload: error,
});

export const getClients = () => {
  return async (dispatch) => {
    dispatch(getClientsRequest());
    try {
      const clients = await api.fetchClients();
      dispatch(getClientsSuccess(clients));
      return { success: true, data: clients };
    } catch (error) {
      dispatch(getClientsFailure(error));
      return { success: false, message: error };
    }
  };
};

// export const updateClientRequest = (id, clientData) => ({
//   type: actionTypes.UPDATE_CLIENT_REQUEST,
//   payload: { id, clientData },
// });

// export const updateClientSuccess = (message) => ({
//   type: actionTypes.UPDATE_CLIENT_SUCCESS,
//   payload: message,
// });

// export const updateClientFailure = (error) => ({
//   type: actionTypes.UPDATE_CLIENT_FAILURE,
//   payload: error,
// });

// export const updateClientById = (id, clientData) => {
//   return async (dispatch) => {
//     dispatch(updateClientRequest(id, clientData));
//     try {
//       const response = await api.updateClient(id, clientData);
//       dispatch(updateClientSuccess(response.message));
//       return { success: true, message: response.message };
//     } catch (error) {
//       dispatch(updateClientFailure(error));
//       return { success: false, message: error };
//     }
//   };
// };
export const updateClientRequest = (id, clientData) => ({
  type: actionTypes.UPDATE_CLIENT_REQUEST,
  payload: { id, clientData },
});

export const updateClientSuccess = (message) => ({
  type: actionTypes.UPDATE_CLIENT_SUCCESS,
  payload: message,
});

export const updateClientFailure = (error) => ({
  type: actionTypes.UPDATE_CLIENT_FAILURE,
  payload: error,
});

export const updateClientById = (id, clientData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    clientData.updated_by = user.user_name;

    dispatch(updateClientRequest(id, clientData));
    try {
      const response = await api.updateClient(id, clientData);
      dispatch(updateClientSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateClientFailure(error));
      return { success: false, message: error };
    }
  };
};
export const deleteClientRequest = (id) => ({
  type: actionTypes.DELETE_CLIENT_REQUEST,
  payload: id,
});

export const deleteClientSuccess = (message) => ({
  type: actionTypes.DELETE_CLIENT_SUCCESS,
  payload: message,
});

export const deleteClientFailure = (error) => ({
  type: actionTypes.DELETE_CLIENT_FAILURE,
  payload: error,
});

export const deleteClientById = (id) => {
  return async (dispatch) => {
    dispatch(deleteClientRequest(id));
    try {
      const response = await api.deleteClient(id);
      dispatch(deleteClientSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteClientFailure(error));
      return { success: false, message: error };
    }
  };
};

export const SingleDataRequest = (ClientDataInput) => ({
  type: actionTypes.LOGIN_REQUEST,
  payload: ClientDataInput,
});

export const SingleDataSuccess = (user) => ({
  type: actionTypes.LOGIN_SUCCESS,
  payload: user,
});

export const SingleDataFailure = (error) => ({
  type: actionTypes.LOGIN_FAILURE,
  payload: error,
});

export const submitForm = (formData) => {
  return {
    type: 'SUBMIT_FORM',
    payload: formData,
  };
};


export const clinetMasterSingleDataInput = (ClientDataInput) => {
  return async (dispatch) => {
    dispatch(SingleDataRequest(ClientDataInput));
    try {
      const response = await api.clientMasterDataInput(ClientDataInput);
      if (response.status === 200) {
        dispatch(SingleDataSuccess(response.data.user));
        return { success: true };
      } else {
        dispatch(SingleDataFailure(response.message || 'SingleData input failed'));
        return { success: false, message: response.message };
      }
    } catch (error) {
      dispatch(SingleDataFailure(error || 'An error occurred'));
      return { success: false, message: error };
    }
  };
};


export const getClientImportantBackupAction = (current_month, client_id) => {
  return async () => {
    try {
      const data = await api.getClientImportantBackup(current_month);
      let rows = Array.isArray(data) ? data : [];
      if (client_id) {
        rows = rows.filter((r) => String(r.client_id) === String(client_id));
      }
      return { success: true, data: rows };
    } catch (error) {
      const message =
        typeof error === 'string' ? error : error?.message || 'Failed to load organization backup report';
      return { success: false, message };
    }
  };
};
